const srcChargebee = 'https://js.chargebee.com/v2/chargebee.js';
const srcChargebeeForSelector = 'https://js.chargebee.com'
import Env from 'Services/Env.js';

window.ChargebeeGlobal = {
    clearChargebeeScript: function() {
        const scriptsToRemove = document.querySelectorAll(`script[src*="${srcChargebeeForSelector}"]`)
        for (const scriptToRemoveElement of scriptsToRemove) {
            scriptToRemoveElement.remove();
        }
        const stylesheetsToRemove = document.querySelectorAll(`link[href*="${srcChargebeeForSelector}"]`)
        for (const stylesheetToRemoveElement of stylesheetsToRemove) {
            stylesheetToRemoveElement.remove();
        }
    },
    initChargebeeScript: function()  {
        return new Promise((resolve)=>{
            ChargebeeGlobal.clearChargebeeScript();
            const script = document.createElement('script');
            script.setAttribute('src', srcChargebee);
            script.setAttribute('type', 'application/javascript');
            script.setAttribute('id', 'chargebee-script');
            document.body.appendChild(script);
            script.addEventListener('load', () => {
                resolve();
            });
        });
    },
    initCbPortal: async function(chargebeeId = null){
        return new Promise((resolve) => {
            let chargebeeInstance = null;
            try {
                chargebeeInstance = Chargebee.getInstance();
                chargebeeInstance.closeAll();
                if(chargebeeId){
                    chargebeeInstance.logout();
                }
            } catch (error) {
                chargebeeInstance = window.Chargebee.init({
                    site: Env.get('chargebee').site ?? '',
                });
            }
            const url = chargebeeId ? `/rest/chargebee/portal-session?chargebee_id=${chargebeeId}` : `/rest/chargebee/portal-session`
            let cbPortal = chargebeeInstance.createChargebeePortal();
            chargebeeInstance.setPortalSession(() => {
                return axios
                    .get(url)
                    .then((response) => response.data)
                    .catch(() => {
                        this.$pushToast({
                            type: 'error',
                            icon: true,
                            text: this.$l10n.__(
                                'Ce service est indisponible, veuillez réessayer plus tard',
                            ),
                        });
                    });
            });
            resolve(cbPortal)
        })
    },
    openCbPortalSection: async function(section, params= {}, chargebeeId)  {
        await ChargebeeGlobal.initChargebeeScript();
        const cbPortal = await ChargebeeGlobal.initCbPortal(chargebeeId);
        cbPortal.openSection({
            sectionType: Chargebee.getPortalSections()[section],
            params
        }, {
            close: () => {
                ChargebeeGlobal.clearChargebeeScript();
            },
            paymentSourceUpdate: (status) => {
                if(status !== 'error'){
                    window.sellsyapp.$trigger('chargebee:payment:source:updated')
                }
            },
            paymentSourceAdd : (status) => {
                if(status !== 'error'){
                    window.sellsyapp.$trigger('chargebee:payment:source:add')
                }
            },
        });
    },
}
